import type { StorageKeys } from '@/utils/menu/getMenuItemsOrder';

type updateActiveItemType<TData> = {
    storageKey: StorageKeys;
    itemsList: TData[];
    itemSelectedId: number;
    callback: () => void;
};

export function updateActiveItem<TData extends { id: number }>({
    storageKey,
    itemsList,
    itemSelectedId,
    callback
}: updateActiveItemType<TData>) {
    callback();
    const itemsInStorage = localStorage.getItem(storageKey);
    const itemsInStorageParsed: number[] = itemsInStorage ? JSON.parse(itemsInStorage) : [];
    let localStorageList: number[] = [];
    if (itemsInStorageParsed?.length) {
        const sortedItems = itemsInStorageParsed.map((id) =>
            itemsList.find((item) => item.id === id)
        );
        localStorageList = sortedItems
            ?.filter((item) => item?.id !== itemSelectedId)
            .map((item) => item?.id);
    }
    if (!itemsInStorageParsed?.length) {
        localStorageList = itemsList
            ?.filter((item) => item?.id !== itemSelectedId)
            .map((item) => item.id);
    }

    localStorage.setItem(storageKey, JSON.stringify([itemSelectedId, ...localStorageList]));
}
